import AddAllToBagConnector from './addAllToBag.props';
import AddAllToBagComponent from './addAllToBag.component';

export default AddAllToBagConnector(AddAllToBagComponent);
